import { useState, useEffect } from 'react'

function validateIsMobile(_width) {
  if (typeof window === 'undefined') {
    return true
  }
  return window.innerWidth < _width
}

export default function useMediaQuery(maxWidth = 1024) {
  const [isMobile, setIsMobile] = useState(true)

  useEffect(() => {
    if (window) {
      const handleResize = () => {
        setIsMobile(validateIsMobile(maxWidth))
      }
      window.addEventListener('resize', handleResize)
      handleResize()
      return () => {
        window.removeEventListener('resize', handleResize)
      }
    }
  }, [maxWidth])

  return isMobile
}
